// extracted by mini-css-extract-plugin
module.exports = {"componentsMapCanvas":"styles_componentsMapCanvas__3YDqo"};